module.exports = __webpack_public_path__ + "static/img/startripvan.c774c6a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icon/services/startripvan.png
// module id = tFym
// module chunks = 1